import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { reactive } from 'vue'
import { useTemplateStore } from 'src/stores'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'
import { ITemplateDeleteItemParam } from 'src/common/interfaces'
import BaseTemplateReceiptLayers from './BaseTemplateReceiptLayers.vue'
import BaseTemplateDigitalMenuLayers from './BaseTemplateDigitalMenuLayers.vue'

interface IState {
  deleteItem: ITemplateDeleteItemParam | null
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseTemplateLayers' },
  __name: 'BaseTemplateLayers',
  setup(__props) {



const templateStore = useTemplateStore()
const { t } = translate(translationObject)

const state = reactive<IState>({ deleteItem: null })

function handleDeleteItem() {
  if (state.deleteItem) templateStore.handleDeleteItem(state.deleteItem)
  state.deleteItem = null
}

return (_ctx: any,_cache: any) => {
  const _component_BasePopup = _resolveComponent("BasePopup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseTemplateLayers q-pt-lg q-pl-lg q-pr-20 q-pb-lg scroll hide-scrollbar transition", { 'bg-white absolute absolute-top-left full-height shadow-2': _ctx.$q.screen.lt.md }])
  }, [
    (_unref(templateStore).isDigitalMenu)
      ? (_openBlock(), _createBlock(BaseTemplateDigitalMenuLayers, {
          key: 0,
          onDelete: _cache[0] || (_cache[0] = ($event: any) => (state.deleteItem = $event))
        }))
      : (_openBlock(), _createBlock(BaseTemplateReceiptLayers, {
          key: 1,
          onDelete: _cache[1] || (_cache[1] = ($event: any) => (state.deleteItem = $event))
        })),
    _createVNode(_component_BasePopup, {
      "model-value": Boolean(state.deleteItem),
      text: _unref(t)('layers.delete.title'),
      icon: "trash",
      "has-warning": false,
      "is-delete-modal": "",
      "right-button-label": _unref(t)('layers.delete.yes'),
      "right-button-event": "delete",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (!$event && (state.deleteItem = null))),
      onDelete: handleDeleteItem,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (state.deleteItem = null))
    }, null, 8, ["model-value", "text", "right-button-label"])
  ], 2))
}
}

})